export default {
  name: 'misc.occupation',
  key: 'occupation',
  attributes: {
    experminents: {
      key: 'experminents',
      name: 'entity.researchBase.occupation.experminents',
    },
    scientists: {
      key: 'scientists',
      name: 'entity.researchBase.occupation.scientists',
    },
    researchers: {
      key: 'researchers',
      name: 'entity.researchBase.occupation.researchers',
    },
    secret: {
      key: 'secret',
      name: 'entity.researchBase.occupation.secret',
    },
    alien: {
      key: 'alien',
      name: 'entity.researchBase.occupation.alien',
    },
  },
};
